import mongsomBannerImg1 from './../asset/image/mainbanner.jpg';
import mongsomBannerImg2 from '../asset/image/mainbanner2.jpg';

export const simpleImageBanners = [
  {
    id: 2,
    image: mongsomBannerImg1,
    link: '/shop-detail/9',
  },
  {
    id: 3,
    image: mongsomBannerImg2,
    link: '/shop-detail/4',
  },
];
